import { Either } from 'src/utils/either';

import { httpResponseHandler } from 'src/http/http-response-handler';

import {
  HttpTypes,
  BadRequestError,
  ConnectionError,
  UnexpectedError,
  AccessDeniedError,
  InternalServerError,
  TooManyRequestsError,
} from '../../http';
import {
  ThemeBulkDeleteResponse,
  ThemeDeletionVerificationResponse,
  ThemeStatus,
} from '../../types/products';

export class ThemesRepository {
  constructor(private api: HttpTypes.HttpClient) {}

  async getThemesList(): Promise<
    | Either<
        | BadRequestError
        | UnexpectedError
        | InternalServerError
        | AccessDeniedError
        | ConnectionError
        | TooManyRequestsError,
        undefined
      >
    | any
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'get',
      url: `benefits/product-theme/list`,
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }

  async getThemeDetails(
    id: string
  ): Promise<
    | Either<
        | BadRequestError
        | UnexpectedError
        | InternalServerError
        | AccessDeniedError
        | ConnectionError
        | TooManyRequestsError,
        undefined
      >
    | any
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'get',
      url: `benefits/product-theme/by-id/${id}`,
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }

  async createTheme(
    theme: any
  ): Promise<
    | Either<
        | BadRequestError
        | UnexpectedError
        | InternalServerError
        | AccessDeniedError
        | ConnectionError
        | TooManyRequestsError,
        undefined
      >
    | any
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'post',
      url: `benefits/product-theme/`,
      body: theme,
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }

  async updateTheme(
    theme: any
  ): Promise<
    | Either<
        | BadRequestError
        | UnexpectedError
        | InternalServerError
        | AccessDeniedError
        | ConnectionError
        | TooManyRequestsError,
        undefined
      >
    | any
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'post',
      url: `benefits/product-theme/update`,
      body: theme,
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }

  async changeThemeStatus(
    themeId: string,
    status: ThemeStatus
  ): Promise<Either<Error, { status: 'success'; themeId: string; themeStatus: ThemeStatus }>> {
    const request: HttpTypes.HttpRequest = {
      method: 'put',
      url: `benefits/product-theme/${themeId}/status`,
      body: { status },
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }

  async deleteThemes(themeIds: string[]): Promise<Either<Error, ThemeBulkDeleteResponse>> {
    const request: HttpTypes.HttpRequest = {
      method: 'delete',
      url: `benefits/product-theme`,
      body: { themeIds },
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }

  async verifyThemesDeletion(
    themeIds: string[]
  ): Promise<Either<Error, ThemeDeletionVerificationResponse>> {
    const request: HttpTypes.HttpRequest = {
      method: 'post',
      url: `benefits/product-theme/verify-deletion`,
      body: { themeIds },
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }

  async getProductsByTheme(
    id: string
  ): Promise<
    | Either<
        | BadRequestError
        | UnexpectedError
        | InternalServerError
        | AccessDeniedError
        | ConnectionError
        | TooManyRequestsError,
        undefined
      >
    | any
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'get',
      url: `benefits/product-theme/products-by-theme-adm/${id}`,
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }
}
